import { Router } from "@angular/router";

export const toollist =  [
    {
        "Type": "Button",
        "Label": "Nouvel incident",
        "Color": "accent",
        "Icon": "add",
        "Method": "newIncident"
    },
]